import apiClient, { unwrapData } from "./apiClient";

export async function getCampaigns(options = {}) {
  const response = await apiClient.get("/api/campaigns", options);
  return unwrapData(response);
}

export async function getCampaign(id, options = {}) {
  const response = await apiClient.get(`/api/campaigns/${encodeURIComponent(id)}`, options);
  return unwrapData(response);
}

export async function createCampaign(payload, options = {}) {
  const response = await apiClient.post("/api/campaigns", {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function uploadCampaignTargets(formData, options = {}) {
  const response = await apiClient.upload("/api/campaigns/upload-targets", {
    ...options,
    formData,
  });

  return unwrapData(response);
}

export async function runCampaignAction(id, action, options = {}) {
  const actionEndpoints = {
    start: "start",
    pause: "pause",
    resume: "resume",
    cancel: "cancel",
  };
  const endpoint = actionEndpoints[action];
  const timeoutMs = action === "start" || action === "resume" ? 60000 : 20000;

  if (!endpoint) {
    const response = await apiClient.post(`/api/campaigns/${encodeURIComponent(id)}/action`, {
      timeoutMs,
      ...options,
      body: { action },
    });

    return unwrapData(response);
  }

  const response = await apiClient.post(`/api/campaigns/${encodeURIComponent(id)}/${endpoint}`, {
    timeoutMs,
    ...options,
    body: options.body || {},
  });

  return unwrapData(response);
}

export async function startCampaign(id, payload = {}, options = {}) {
  const response = await apiClient.post(`/api/campaigns/${encodeURIComponent(id)}/start`, {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function pauseCampaign(id, payload = {}, options = {}) {
  const response = await apiClient.post(`/api/campaigns/${encodeURIComponent(id)}/pause`, {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function resumeCampaign(id, payload = {}, options = {}) {
  const response = await apiClient.post(`/api/campaigns/${encodeURIComponent(id)}/resume`, {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function cancelCampaign(id, payload = {}, options = {}) {
  const response = await apiClient.post(`/api/campaigns/${encodeURIComponent(id)}/cancel`, {
    ...options,
    body: payload,
  });

  return unwrapData(response);
}

export async function deleteCampaign(id, options = {}) {
  const response = await apiClient.del(`/api/campaigns/${encodeURIComponent(id)}`, options);
  return unwrapData(response);
}
